const buttons = document.getElementsByClassName("scroll-to")
for (let button of buttons) {
  button.addEventListener("click", (e) => {
    const header = document.querySelector("header")
    const elementPosition = e.srcElement.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - 20

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  })
}
